import React, { FunctionComponent, Suspense } from 'react'
import PropTypes from 'prop-types'

import Modal from '..'
import PopupModal from '../PopupModal'
import Field from '../../fields'

interface Medication {
  id: string
}

interface Resident {
  name: {
    first: string
    last: string
  }
}

interface EmarMedicationQuantityModalProps {
  fields: any
  isOpen: boolean
  medication: Medication
  resident: Resident
  showToast: (props: any) => void
  updateItem: (props: any) => void
  testId?: string
}

const EmarMedicationQuantityModal: FunctionComponent<
  EmarMedicationQuantityModalProps
> = (props) => {
  const { fields, isOpen, medication, resident, testId, ...formProps } = props

  if (!isOpen) return null

  return (
    <PopupModal
      buttonDisabled={!(fields.quantity && fields.quantityType)}
      buttonIcon="check"
      buttonType="success"
      confirmText="Save"
      footerStyle={styles.footerStyle}
      // onConfirm={() => handleSubmit(props)}
      style={styles.popupModal}
      supportArticle="https://support.logmycare.co.uk/"
      title="Medication Quantity"
      data-testid={
        testId
          ? `${testId}-medication-quantity-modal`
          : 'medication-quantity-modal'
      }
      {...formProps}
    >
      <div
        style={styles.quantityFieldsContainer}
        data-testid={testId ? `${testId}-quantity-fields` : 'quantity-fields'}
      >
        <div style={styles.quantityFieldEntry}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="quantity"
              formFieldStyle={{ minWidth: 150 }}
              style={{ maxWidth: 150 }}
              type="number"
              layout="no-label"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.quantityFieldEntry}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={MODAL_ID}
              keys="quantityType"
              label="Quantity Type"
              layout="no-label"
              formFieldStyle={{ minWidth: 150, maxWidth: 150 }}
              options={QUANTITY_OPTIONS}
              type="select"
              values={fields}
            />
          </Suspense>
        </div>
      </div>
      <div style={styles.commentFieldTitle}>Any other comments</div>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          formId={MODAL_ID}
          keys="quantityComment"
          layout="no-label"
          style={styles.commentField}
          type="textarea"
          values={fields}
        />
      </Suspense>
    </PopupModal>
  )
}

const MODAL_ID = 'medicationQuantity'
const QUANTITY_OPTIONS = [
  { value: 'ml', label: 'ml' },
  { value: 'patches', label: 'patches' },
  { value: 'tablets', label: 'tablets' },
  { value: 'grams', label: 'grams' },
  { value: 'capsules', label: 'capsules' },
  { value: 'lozenges', label: 'lozenges' },
  { value: 'units', label: 'units' }
]

const styles = {
  commentFieldTitle: {
    fontWeight: 700,
    lineHeight: '22px',
    marginBottom: 8
  },
  footerStyle: {
    justifyContent: 'space-between'
  },
  note: {
    fontSize: 12,
    lineHeight: '18px',
    marginBottom: 16
  },
  popupModal: {
    minWidth: 630
  },
  quantityFieldsContainer: {
    display: 'flex',
    flexFlow: 'row wrap'
  },
  quantityFieldEntry: {
    margin: '0 12px 12px 0'
  },
  commentField: {
    minHeight: 90
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 16
  }
}

export default Modal(EmarMedicationQuantityModal, MODAL_ID)
